import MetricBase from "models/metrics/MetricBase";
import EmptyUnit from "../../../unit/EmptyUnit";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricPlmMiss extends MetricBase {
    constructor() {
        super({
            field: "metric_plm_miss",
            defaultVisibility: false,
            unit: new EmptyUnit(),
           /* chartName: i18n.t("metrics.tripadvisor.spent.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.spent.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.spent.tooltip"), */
            group: new PerformanceGroup(),
        });
    }
}

export default MetricPlmMiss;